import React from 'react'
import {Toaster} from "react-hot-toast"
import { BrowserRouter } from 'react-router-dom'
import './App.css'
import { AppRouter } from './Routes'

function App() {
  return (
    <BrowserRouter>
      <Toaster />
      <AppRouter />
    </BrowserRouter>
  )
}

export default App
